import React from 'react';

export const Logo = ({ variant = 'default', className = '' }) => {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="logo">
      {/* Logo Icon - Blue box with upload arrow and orange dot */}
      <div className="relative w-10 h-10">
        <div className="absolute inset-0 bg-[#0088CC] rounded-lg flex items-center justify-center">
          <svg 
            viewBox="0 0 24 24" 
            className="w-6 h-6 text-white"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
            <polyline points="16 6 12 2 8 6" />
            <line x1="12" y1="2" x2="12" y2="15" />
          </svg>
        </div>
        {/* Orange accent dot */}
        <div className="absolute -top-1 -right-1 w-3 h-3 bg-[#FF6600] rounded-full" />
      </div>
      
      {/* Logo Text */}
      <div className="flex items-baseline">
        <span 
          className="text-xl font-bold tracking-tight text-[#0088CC]"
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          share
        </span>
        <span 
          className="text-xl font-bold tracking-tight text-[#FF6600]"
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          box
        </span>
      </div>
    </div>
  );
};

export default Logo;
